module.exports = __webpack_public_path__ + "img/react.404417d2.png";